interface Props {
  className?: string;
  color?: string;
}

export function CardsIcon({
  className = "h-8 w-8",
  color = "currentColor",
}: Props) {
  return (
    <svg
      className={className}
      viewBox="0 0 292.527 292.527"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      aria-label="Cards"
    >
      <defs>
        <mask id="cube-cutout">
          <rect width="100%" height="100%" fill="white" />
          <g
            transform="translate(160, 110) scale(0.8)"
            fill="none"
            stroke="black"
            strokeWidth="5.5"
            strokeLinejoin="round"
          >
            <polygon points="50,0 100,28 50,56 0,28" />
            <polygon points="0,28 50,56 50,112 0,84" />
            <polygon points="100,28 50,56 50,112 100,84" />
          </g>
        </mask>
      </defs>
      <g mask="url(#cube-cutout)">
        <path d="M265.035,262.704h0.091c0.452-1.782,0.955-3.925,1.458-5.748l2.371-7.571h-7.891l2.417,7.576C264.075,258.824,264.573,260.927,265.035,262.704z" />
        <path d="M137.888,54.908h-0.094c-0.452,1.782-0.957,3.926-1.455,5.749l-2.372,7.576h7.894l-2.42-7.576C138.845,58.788,138.339,56.69,137.888,54.908z" />
        <path d="M30.603,260.739c1.338,8.5,5.903,15.98,12.865,21.048c5.575,4.062,12.142,6.19,18.908,6.19c1.678,0,3.375-0.132,5.07-0.401l44.125-6.932c1.777,0.31,3.583,0.487,5.408,0.487c1.678,0,3.375-0.127,5.07-0.396l3.999-0.63c3.503,1.655,7.383,2.666,11.517,2.666h127.937c14.924,0,27.025-12.106,27.025-27.03V61.139c0-14.929-12.102-27.03-27.025-27.03h-20.078l-0.365-2.326c-1.336-8.5-5.901-15.975-12.863-21.048c-6.956-5.068-15.457-7.13-23.978-5.784l-54.183,8.511L27.223,31.656C9.674,34.414-2.364,50.938,0.394,68.497L30.603,260.739z M145.553,81.192l-2.783-8.719h-9.719l-2.646,8.719h-5.794l9.859-30.747h7.16l9.993,30.747H145.553z M257.367,236.431l2.783,8.714h9.719l2.646-8.714h5.794l-9.861,30.747h-7.16l-9.993-30.747H257.367z M83.434,35.084l126.394-19.865c5.748-0.919,11.522,0.488,16.239,3.92c4.713,3.433,7.811,8.496,8.714,14.259l0.106,0.711h-97.332c-14.924,0-27.03,12.105-27.03,27.03v194.603c0,5.113,1.498,9.842,3.968,13.914l-2.704,0.426c-2.704-0.67-5.283-1.853-7.602-3.544c-4.717-3.433-7.81-8.495-8.716-14.259L65.26,60.037C63.394,48.145,71.546,36.947,83.434,35.084z M28.77,41.934l32.326-4.636c-5.06,6.729-7.513,15.396-6.104,24.349l30.209,192.248c1.15,7.312,4.702,13.862,10.105,18.772l-29.478,4.637c-5.769,0.894-11.53-0.493-16.24-3.921c-4.717-3.433-7.81-8.5-8.716-14.259L10.661,66.877C8.795,54.995,16.948,43.798,28.77,41.934z" />
      </g>
    </svg>
  );
}
